import { render, staticRenderFns } from "./businessBanner.vue?vue&type=template&id=4e9c4964&scoped=true"
import script from "./businessBanner.vue?vue&type=script&lang=js"
export * from "./businessBanner.vue?vue&type=script&lang=js"
import style0 from "./businessBanner.vue?vue&type=style&index=0&id=4e9c4964&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e9c4964",
  null
  
)

export default component.exports